var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFavoritesM(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-/-Favorites-m",
    stroke: "none",
    strokeWidth: 1,
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8,0 C7.65799154,0 7.31598308,0.14616441 7.12097826,0.438493231 L4.82892158,3.8885619 L0.770821225,4.96370414 C0.428812768,5.05395331 0.159806115,5.30802433 0.0508034198,5.63959192 C-0.0581992758,5.97115951 0.0108024305,6.33019423 0.232807921,6.60094173 L2.86887311,9.80674907 L2.65686787,13.9199529 C2.63886742,14.268197 2.7998714,14.5987836 3.08787853,14.8028252 C3.26988303,14.9332941 3.48488834,14.999019 3.70289373,14.999019 C3.82889685,14.999019 3.95589999,14.9774377 4.07790301,14.9332941 L8,13.4628213 L11.924097,14.9332941 C12.0451,14.9784187 12.1711031,15 12.2961062,15 C12.5151117,15 12.730117,14.9332941 12.9121215,14.8028252 C13.2001286,14.5987836 13.3611326,14.268197 13.3431321,13.9189719 L13.1311269,9.80674907 L15.7671921,6.60094173 C15.9891976,6.33019423 16.0581993,5.97115951 15.9491966,5.63959192 C15.8401939,5.30802433 15.5711872,5.05395331 15.2251787,4.9617422 L11.1710784,3.8885619 L8.87902174,0.438493231 L8.87802171,0.437512262 C8.68401692,0.14616441 8.34200846,0 8,0",
    id: "Fill-1",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavoritesM);
export default __webpack_public_path__ + "static/media/Favorites-m.0c9171939afffa8bc628c5d2bddd03f2.svg";
export { ForwardRef as ReactComponent };